import CommonDelete from "@/components/common/Delete";
import { singleProp } from "@/interface/dataInterface";
import { FC } from "react";

const BranchDelete: FC<singleProp> = ({prop}) => {
    return (
        <CommonDelete title="Delete" id={prop} resource="branches"/>
    )
}

export default BranchDelete